<app-list-details-panel
  #appListDetailsPanel
  [title]="'Invoices'"
  [cardTitleKey]="'customer.name'"
  [cardSubTitleKey]="'amount.totalAmount'"
  [keysToDisplay]="['invoiceNo','invoiceDate']"
  [searchBarConfig]="searchBarConfig"
  [(dataListRequest)]="tableListRequest"
  [dataListResponse]="tableListData"
  [openedCardId]="selectedInvoiceId"
  [showSecondaryActionsBtn]="true"
  [secondaryActionBtnText]="'Misc.'"
  [filterConfig]="filterConfig"

  (primaryButtonClick)="addDocumentInvoice()"
  (secondaryButtonClick)="addMiscellaneousInvoice()"
  (tosTableAction)="getTableList()"
  (backButtonClick)="goBack()"
  (cardOpened)="handleCardOpened($event,appListDetailsPanel)"
></app-list-details-panel>

<ng-template #cancelInvoiceModalContent>
  <div class="cancel_invoice_modal_container">
    <label class="required_field_label">Remarks</label>
    <textarea placeholder="Enter Remarks" [(ngModel)]="cancelInvoiceDescription"></textarea>
    <div class="action_btns">
      <div class="btn secondary_button" (click)="handleModalCancel()">Cancel</div>
      <div class="btn primary_button" (click)="cancelInvoice()">Save</div>
    </div>
  </div>
</ng-template>
